import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly9C2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9C/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9C/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9C/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9C/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9C/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9C/6.webp`;

  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                 TOPIC: PANCHAKOSHA HEALTH HACK
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 9C   DATE: 9 JULY & 13 July 2026
                </Typography>

                <br />
               <Typography variant={'subtitle1'} align={'justify'}>
     The students of Class 9 C presented a meaningful two-day assembly on the theme Panchakosha – The Five
Dimensions of Holistic Development, drawing inspiration from the Taittiriya Upanishad and the vision of NEP
2020, the assembly highlighted the importance of nurturing every dimension of an individual's personality. The
first day's presentation briefly introduced the concept of the Panchakosha through the dialogue between Bhrigu
and Varuna, emphasising that true education extends beyond academic learning to holistic development.
                <br></br>
               Building on this foundation, the second day's interactive skit demonstrated how the five koshas—Annamaya,
Pranamaya, Manomaya, Vijnanamaya and Anandamaya can be nurtured through simple daily practices such as
healthy eating, mindful breathing, gratitude, critical thinking and joyful living. Through relatable situations and
engaging performances, the students effectively conveyed that true success lies in achieving balance between
the body, energy, mind, intellect and inner happiness. The assembly concluded with an inspiring message,
encouraging everyone to incorporate these timeless principles into their daily lives.
                <br></br>
                The Principal appreciated the students for their sincere efforts and remarked that they had truly captured the
essence of NEP 2020&'s vision through their meaningful presentation on the Panchakosha.
<br></br>
</Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
               ‘Holistic growth begins with the harmony of the five koshas.’
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 10A 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly9C2026;
